var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7935 23.8371C19.7935 24.4854 19.2637 25.0164 18.6033 25.0164C17.9429 25.0164 17.4131 24.4854 17.4131 23.8371C17.4131 23.1888 17.9429 22.6577 18.6033 22.6577C19.2637 22.6577 19.7935 23.1888 19.7935 23.8371Z",
    fill: "#19A7CE",
    stroke: "#19A7CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9925 23.8371C27.9925 24.4854 27.4627 25.0164 26.8023 25.0164C26.1419 25.0164 25.6121 24.4854 25.6121 23.8371C25.6121 23.1888 26.1419 22.6577 26.8023 22.6577C27.4627 22.6577 27.9925 23.1888 27.9925 23.8371Z",
    fill: "#19A7CE",
    stroke: "#19A7CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1912 23.8371C36.1912 24.4854 35.6614 25.0164 35.001 25.0164C34.3406 25.0164 33.8108 24.4854 33.8108 23.8371C33.8108 23.1888 34.3406 22.6577 35.001 22.6577C35.6614 22.6577 36.1912 23.1888 36.1912 23.8371Z",
    fill: "#19A7CE",
    stroke: "#19A7CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7935 33.6198C19.7935 34.2681 19.2637 34.7991 18.6033 34.7991C17.9429 34.7991 17.4131 34.2681 17.4131 33.6198C17.4131 32.9715 17.9429 32.4404 18.6033 32.4404C19.2637 32.4404 19.7935 32.9715 19.7935 33.6198Z",
    fill: "#19A7CE",
    stroke: "#19A7CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9925 33.6198C27.9925 34.2681 27.4627 34.7991 26.8023 34.7991C26.1419 34.7991 25.6121 34.2681 25.6121 33.6198C25.6121 32.9715 26.1419 32.4404 26.8023 32.4404C27.4627 32.4404 27.9925 32.9715 27.9925 33.6198Z",
    fill: "#19A7CE",
    stroke: "#19A7CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1912 33.6198C36.1912 34.2681 35.6614 34.7991 35.001 34.7991C34.3406 34.7991 33.8108 34.2681 33.8108 33.6198C33.8108 32.9715 34.3406 32.4404 35.001 32.4404C35.6614 32.4404 36.1912 32.9715 36.1912 33.6198Z",
    fill: "#19A7CE",
    stroke: "#19A7CE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7935 43.402C19.7935 44.0503 19.2637 44.5814 18.6033 44.5814C17.9429 44.5814 17.4131 44.0503 17.4131 43.402C17.4131 42.7537 17.9429 42.2227 18.6033 42.2227C19.2637 42.2227 19.7935 42.7537 19.7935 43.402Z",
    fill: "#19A7CE",
    stroke: "#19A7CE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9925 43.402C27.9925 44.0503 27.4627 44.5814 26.8023 44.5814C26.1419 44.5814 25.6121 44.0503 25.6121 43.402C25.6121 42.7537 26.1419 42.2227 26.8023 42.2227C27.4627 42.2227 27.9925 42.7537 27.9925 43.402Z",
    fill: "#19A7CE",
    stroke: "#19A7CE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1912 43.402C36.1912 44.0503 35.6614 44.5814 35.001 44.5814C34.3406 44.5814 33.8108 44.0503 33.8108 43.402C33.8108 42.7537 34.3406 42.2227 35.001 42.2227C35.6614 42.2227 36.1912 42.7537 36.1912 43.402Z",
    fill: "#19A7CE",
    stroke: "#19A7CE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6054 46.6522C44.6054 49.0435 42.6489 51 40.2576 51H13.3478C10.9565 51 9 49.0435 9 46.6522V5.34783C9 2.95652 10.9565 1 13.3478 1H40.2576C42.6489 1 44.6054 2.95652 44.6054 5.34783V46.6522Z",
    stroke: "#146C94",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2947 11.7905H37.3088",
    stroke: "#19A7CE",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.b29b85569afe980e4e9c6fb9affd6637.svg";
export { ForwardRef as ReactComponent };